import SiteHeader from '@/pages/home/components/SiteHeader';
import HeroSection from '@/pages/home/components/HeroSection';
import RecapSection from '@/pages/home/components/RecapSection';
import TimelineSection from '@/pages/home/components/TimelineSection';
import BackgroundSection from '@/pages/home/components/BackgroundSection';
import ReversalSection from '@/pages/home/components/ReversalSection';
import UpdatesSection from '@/pages/home/components/UpdatesSection';
import TrendingSection from '@/pages/home/components/TrendingSection';
import FaqSection from '@/pages/home/components/FaqSection';
import AboutSection from '@/pages/home/components/AboutSection';
import SiteFooter from '@/pages/home/components/SiteFooter';
import BackToTop from '@/pages/home/components/BackToTop';
import { faqs, siteContact, trendingTopics } from '@/mocks/home';

const structuredData = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'Organization',
      '@id': 'https://mcgear.cn/#organization',
      name: '51.吃瓜',
      url: 'https://mcgear.cn/',
      email: siteContact.email,
      description: '事件补课专区，提供前情回顾、事件全貌、背景资料、反转记录与后续进度的结构化梳理。',
    },
    {
      '@type': 'WebSite',
      '@id': 'https://mcgear.cn/#website',
      url: 'https://mcgear.cn/',
      name: '51.吃瓜',
      inLanguage: 'zh-CN',
      publisher: { '@id': 'https://mcgear.cn/#organization' },
    },
    {
      '@type': 'WebPage',
      '@id': 'https://mcgear.cn/#webpage',
      url: 'https://mcgear.cn/',
      name: '51.吃瓜 - 吃瓜前情回顾、事件全貌完整补课专区',
      description:
        '前情回顾、事件全貌、背景资料、反转记录、后续进度一次补全。吃瓜吃到一半没跟上？来这里补课。',
      isPartOf: { '@id': 'https://mcgear.cn/#website' },
      inLanguage: 'zh-CN',
    },
    {
      '@type': 'BreadcrumbList',
      itemListElement: [
        { '@type': 'ListItem', position: 1, name: '首页', item: 'https://mcgear.cn/' },
        {
          '@type': 'ListItem',
          position: 2,
          name: '吃瓜补课专区',
          item: 'https://mcgear.cn/#hero',
        },
      ],
    },
    {
      '@type': 'FAQPage',
      mainEntity: faqs.map((faq) => ({
        '@type': 'Question',
        name: faq.q,
        acceptedAnswer: { '@type': 'Answer', text: faq.a },
      })),
    },
    {
      '@type': 'ItemList',
      name: '热门吃瓜事件',
      itemListElement: trendingTopics.map((topic, index) => ({
        '@type': 'ListItem',
        position: index + 1,
        name: topic.title,
        description: topic.summary,
      })),
    },
  ],
};

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <SiteHeader />
      <main>
        <HeroSection />
        <RecapSection />
        <TimelineSection />
        <BackgroundSection />
        <ReversalSection />
        <UpdatesSection />
        <TrendingSection />
        <FaqSection />
        <AboutSection />
      </main>
      <SiteFooter />
      <BackToTop />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
      />
    </div>
  );
}